(function(window, app, overwatch){

    function init(){
        //Open when clicking PS4/Xbox button
        $('[data-js=platform-instructions-button]').bind('click', function(){
            var $this = $(this);
            var platform = $this.data("platform");
            var html = $('[data-js='+platform+'-instructions-container]').html();
            overwatch.lightbox.open({body:html, loader:false, media: false});

            // Hack to add analytics attributes to battle.net app link
            if (platform === 'pc') {
                var $link = $('.lightbox-content > .free-trial-instructions a');
                $link.attr({
                    'data-analytics': 'action-link',
                    'data-analytics-placement': 'PC || Marketing Page - Free Trial Weekend - Download',
                });
            }
        });
    }

    app.extend({ trial: { init: init }});
}(window, window.app, window.overwatch));
